import { get, post, put, del } from "./http";
import { BaseUrlNew } from "./NewSiteUrl";
import { headerDemo } from "./editHeader";

// ++++++++++ 活动形式-统一详情页 ++++++++++

// 获取活动参展品牌商三级联动数据
export const getActivityExhibitionBrands = params =>post("/ActivityService/Activity/GetActivityExhibitionBrands",params);
// 获取商家代理的品类品牌级联列表
export const getActivityExibitionBrandsForBrandBusiness = params =>post("/ActivityService/Activity/GetActivityExibitionBrandsForBrandBusiness",params);
// 获取当前店铺下代理的品类已配置的佣金比例列表
export const getSettingCommissionByBbIdAndGoodsBrandTypeId = params =>post("/ActivityService/Activity/GetSettingCommissionByBbIdAndGoodsBrandTypeId",params);

// 查询商品编码是否已存在商品表
export const getSelectGoodsByGoodCodeAndBbId = params =>post("/ActivityService/Activity/SelectGoodsByGoodCodeAndBbId",params);
// 获取基础数据
export const getBaseDataList = params =>get("/BaseDataNew/BaseDataNew/GetBaseDataList",params);
// 获取活动类型
export const getMp = params =>get( BaseUrlNew + "/api/activity/sponsorType/mp",params, 1, '1.0');

// 新增/修改特价商品
export const getEditSpecialOfferGoods = params =>post("/ActivityService/Activity/EditSpecialOfferGoods",params);
// 查询特价商品详情
export const getSpecialOfferGoodsDetailById = params =>post("/ActivityService/Activity/GetSpecialOfferGoodsDetailById",params);

// 新增/修改秒杀商品
export const getEditSeckillGoods = (params,headers) =>post("/ActivityService/Activity/EditSeckillGoods",params,headers);
// 查询秒杀商品详情
export const getSeckillGoodsDetailById = params =>post("/ActivityService/Activity/GetSeckillGoodsDetailById",params);

// 新增/修改团购商品
export const getEditGroupBuyGoods = (params,headers) =>post("/ActivityService/Activity/EditGroupBuyGoods",params,headers);
// 查询团购商品详情
export const getGroupBuyGoodsDetailById = params =>post("/ActivityService/Activity/GetGroupBuyGoodsDetailById",params);

// 新增优惠券
export const getInsertActivityCoupon = params =>post("/ActivityService/Activity/InsertActivityCoupon",params);
// 修改优惠券
export const getUpdateActivityCoupon = params =>post("/ActivityService/Activity/UpdateActivityCoupon",params);
// 查询优惠券详情
export const getActivityCouponDetailById = params =>post("/ActivityService/Activity/GetActivityCouponDetailById",params);

// 新增/修改预约签到礼商品
export const getEditReservationGoods = (params,headers) =>post("/ActivityService/Activity/EditReservationGoods",params,headers);
// 查询预约签到礼商品详情
export const getReservationGoodsDetailById = params =>post("/ActivityService/Activity/GetReservationGoodsDetailById",params);

// 新增、编辑到店打卡礼
export const postAddeditToStore = params =>post( BaseUrlNew + "/api/activity/editToStore",params, headerDemo, 1, '1.0');
// 到点打卡礼打卡店铺列表
export const getToStoreGiftBusiness = params =>get( BaseUrlNew + "/api/activity/toStoreGiftBusiness",params, 1, '1.0');
// 到店打卡礼详情
export const getToStoreGiftDetails = params =>get( BaseUrlNew + "/api/activity/toStoreGiftDetails",params, 1, '1.0');

// 新增、编辑连单礼
export const postAddeditContinuityOrder = params =>post( BaseUrlNew + "/api/activity/editContinuityOrder",params, headerDemo, 1, '1.0');
// 连单礼详情
export const getContinuityOrderDetails = params =>get( BaseUrlNew + "/api/activity/continuityOrderDetails",params, 1, '1.0');


// ++++++++++ 平台活动详情页-基本信息 ++++++++++

// 新增活动-1-生成临时活动id
export const getCreateActive = params =>post("/ActivityService/Activity/CreateActive",params);
// 查询活动形式
export const getSelectActiveForm = params =>post("/ActivityService/Activity/SelectActiveForm",params);
// 新增活动-2-新增活动形式
export const getInsertActiveForm = params =>post("/ActivityService/Activity/InsertActiveForm",params);
// 活动形式排序
export const getActiveFormOrde = params =>post("/ActivityService/Activity/ActiveFormOrde",params);
// 删除活动形式
export const getDeleteActiveForm = params =>post("/ActivityService/Activity/DeleteActiveForm",params);
// 修改活动基本信息
export const getUpdateActiveBasicInfo = params =>post("/ActivityService/Activity/UpdateActiveBasicInfo",params, headerDemo);
// 查看基本信息
export const getSelectActiveBasicInfo = params =>post("/ActivityService/Activity/SelectActiveBasicInfo",params);
// 新增活动-3-基本信息
export const getInsertActiveBasicInfo = params =>post("/ActivityService/Activity/InsertActiveBasicInfo",params, headerDemo);
// 获取活动店铺
export const getactivityshop = params =>post( BaseUrlNew + "/api/activity/getactivityshop",params, headerDemo, 1, '1.0');

// 特价商品-分页获取活动店铺商品列表
export const specialpriceGetgoods = params =>post( BaseUrlNew + "/api/activity/specialprice/getgoods",params, headerDemo, 1, '1.0');
// 特价商品-保存
export const specialpriceSavegoods = params =>post( BaseUrlNew + "/api/activity/specialprice/savegoods",params, headerDemo, 1, '1.0');

// ++++++++++ 参展品牌 ++++++++++

// 排序参展品牌
export const getUpdateActiveExhibitionBrandOrde = params =>post("/ActivityService/Activity/UpdateActiveExhibitionBrandOrde",params);
// 查询未添加的参展品牌
export const getSelectUnAddedActivityBrand = params =>post("/ActivityService/Activity/SelectUnAddedActivityBrand",params);
// 获取当前活动所属城市下的所有上架店铺
export const activityGetareashop = params =>get( BaseUrlNew + "/api/activity/getareashop",params, 1, '1.0');
// 新增活动参展店铺
export const activityShopAdd = params => post( BaseUrlNew + "/api/activity/shop/add",params, headerDemo, 1, '1.0');
// 删除活动参展店铺
export const activityShopDel = params =>del( BaseUrlNew + "/api/activity/shop/del",params, 1, '1.0');



// WEBPACK FOOTER //
// ./src/api/addActiviteForm.js